module.exports = __webpack_public_path__ + "img/350x350.51931a92.png";